import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
import { Container } from './styles';

// Importando componente
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';

export default function Password({ location }) {
  const inputRef = useRef(null);
  const [token, setToken] = useState(null);
  const [carregar, setCarregar] = useState(false);

  useEffect(() => {
    async function getToken() {
      const [, tokens] = location.search.split('=');

      setToken(tokens);
    }
    getToken();
  }, [location.search]);

  async function handlerReset(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        password: Yup.string()
          .min(5, 'A senha precisa ter no minimo 5 caracteres ')
          .required('Preencha o campo nova senha'),
        password_confirmation: Yup.string()
          .oneOf(
            [Yup.ref('password')],
            'A confirmação de senha precisa ser igual a nova senha'
          )
          .required('Preencha o campo de confirmação de senha'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put('/password', {
        token,
        password: data.password,
        password_confirmation: data.password_confirmation,
      });
      toast.success('Senha alterada com sucesso.');
      history.push('/');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Token invalido ou expirado.');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <Form ref={inputRef} onSubmit={handlerReset} autoComplete="off">
        <Input
          icon="MdLock"
          label="Nova senha"
          name="password"
          type="password"
        />
        <Input
          icon="MdLock"
          label="Confirmar senha"
          name="password_confirmation"
          type="password"
        />

        <Button size="100%" load={carregar}>
          Editar
        </Button>
      </Form>
    </Container>
  );
}

Password.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};
